import * as storage from 'utils/storage';

import { ACCESS_TOKEN, REFRESH_TOKEN } from '../constants/storage';

/**
 * Persist token to storage.
 *
 * @param {string} accessToken
 * @param {string} refreshToken
 */
export function persist(accessToken: string, refreshToken: string) {
  storage.set(ACCESS_TOKEN, accessToken);
  storage.set(REFRESH_TOKEN, refreshToken);
}

/**
 * Get access token from storage.
 *
 * @returns {string}
 */
export function getAccessToken(): string | undefined {
  const value = storage.get(ACCESS_TOKEN);

  return typeof value === 'string' ? value : undefined;
}

/**
 * Set access token from storage.
 *
 * @param {string} accessToken
 */
export function setAccessToken(accessToken: string) {
  storage.set(ACCESS_TOKEN, accessToken);
}

/**
 * Get refresh token from storage.
 *
 * @returns {string}
 */
export function getRefreshToken(): string | undefined {
  const value = storage.get(REFRESH_TOKEN);

  return typeof value === 'string' ? value : undefined;
}

/**
 * Clear tokens.
 */
export function clear() {
  storage.remove(ACCESS_TOKEN);
  storage.remove(REFRESH_TOKEN);
}
